import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/layout/Sidebar'
import { ToastProvider } from '@/providers/ToastProvider'
import { useRealtime } from '@/hooks/useRealtime'

/**
 * App shell: navy sidebar + scrolling main column. Pages own their padding
 * (`<Page>` gives artboard 01's 32px / 40px with a 24px gap); ticket detail is
 * full-bleed (artboard 02).
 */
export function Layout() {
  return (
    <ToastProvider>
      <Shell />
    </ToastProvider>
  )
}

function Shell() {
  useRealtime()
  return (
    <div className="flex h-full overflow-hidden bg-background">
      <Sidebar />
      <main className="flex min-w-0 grow flex-col overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
